<template>
  <div class="process-cards-mobile">
    <!-- Buscador -->
    <div class="control has-icons-left process-search">
      <input
        v-model="search"
        class="input"
        type="text"
        placeholder="Filtrar procesos…"
      />
      <span class="icon is-left">
        <i class="material-icons">search</i>
      </span>
    </div>

    <!-- Crear proceso (admin) -->
    <div
      v-if="isAdmin"
      class="is-flex is-justify-center process-create"
    >
      <button
        class="button is-dark"
        v-on:click="$emit('create')"
      >
        Crear proceso
        <span class="icon" style="margin-left: 5px">
          <i class="material-icons">add_circle</i>
        </span>
      </button>
    </div>

    <!-- Lista de tarjetas -->
    <div
      v-for="process in filteredProcesses"
      :key="process._id"
      class="box process-card"
      v-on:click="$emit('select', process)"
    >
      <!-- Header: nombre (+ benchmark) y menú -->
      <div class="process-card__header">
        <div class="process-card__title">
          <span
            v-if="process.benchmark === 1"
            class="tag tag-process is-success is-capitalized"
            v-tooltip="'Proceso de referencia (benchmark)'"
          >
            <i class="mdi mdi-database-import-outline"></i>
          </span>
          <strong>{{ process.nombre }}</strong>
        </div>

        <div
          v-if="isAdmin"
          class="dropdown is-right process-card__menu"
          :class="{ 'is-active': openMenuId === process._id }"
          v-on:click.stop
        >
          <div class="dropdown-trigger">
            <button
              class="button is-white is-small"
              aria-haspopup="true"
              v-on:click="toggleMenu(process._id)"
            >
              <span class="icon">
                <i class="mdi mdi-dots-vertical"></i>
              </span>
            </button>
          </div>
          <div class="dropdown-menu" role="menu">
            <div class="dropdown-content">
              <a class="dropdown-item" v-on:click="emitAction('edit', process)">
                <span class="icon"><i class="material-icons">edit</i></span>
                <span>Editar</span>
              </a>
              <a
                class="dropdown-item"
                v-on:click="emitAction('comparison', process)"
              >
                <span class="icon"
                  ><i class="material-icons">compare_arrows</i></span
                >
                <span>Histórico</span>
              </a>
              <a
                class="dropdown-item"
                v-on:click="emitAction('copy-link', process)"
              >
                <span class="icon"><i class="material-icons">share</i></span>
                <span>Copiar enlace</span>
              </a>
              <hr class="dropdown-divider" />
              <a
                class="dropdown-item has-text-danger"
                v-on:click="emitAction('delete', process)"
              >
                <span class="icon"
                  ><i class="material-icons">delete_forever</i></span
                >
                <span>Eliminar</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- Metadatos -->
      <div class="process-card__meta">
        <span class="process-card__meta-item">
          <i class="material-icons">event</i>
          {{ dateProcess(process.created) }}
        </span>
        <span class="process-card__meta-item">
          <i class="material-icons">vpn_key</i>
          {{ process.codigo }}
        </span>
      </div>

      <!-- Histórico + estado -->
      <div class="process-card__footer">
        <span class="process-card__footer-group">
          <span class="is-size-7 has-text-grey">Histórico</span>
          <span
            class="tag is-capitalized"
            :class="historicCount(process) ? 'is-dark' : 'is-warning'"
            v-tooltip="historicLabel(process)"
          >
            {{ historicCount(process) || "No" }}
          </span>
        </span>

        <button
          v-if="isAdmin"
          class="button is-small process-card__toggle"
          :class="process.active ? 'is-dark' : 'is-grey'"
          v-on:click.stop="$emit('toggle', process)"
          v-tooltip="process.active ? 'Deshabilitar proceso' : 'Habilitar proceso'"
        >
          <span class="icon">
            <i class="material-icons">
              {{ process.active ? "toggle_on" : "toggle_off" }}
            </i>
          </span>
          <span>{{ process.active ? "Habilitado" : "Deshabilitado" }}</span>
        </button>
      </div>
    </div>

    <!-- Sin resultados -->
    <p
      v-if="!filteredProcesses.length"
      class="has-text-centered has-text-grey process-empty"
    >
      No hay procesos que coincidan.
    </p>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ProcessCardsMobile",
  props: {
    processes: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      search: "",
      openMenuId: null,
    };
  },
  computed: {
    ...mapState(["tokenUser"]),
    isAdmin() {
      return this.tokenUser ? !!this.tokenUser.admin : false;
    },
    filteredProcesses() {
      const term = this.normalize(this.search);
      if (!term) return this.processes;
      return this.processes.filter((p) => {
        const nombre = this.normalize(p.nombre || "");
        const codigo = this.normalize(p.codigo || "");
        return nombre.includes(term) || codigo.includes(term);
      });
    },
  },
  methods: {
    normalize(value) {
      return String(value)
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },
    dateProcess(d) {
      let date = new Date(d);
      const options = { year: "numeric", month: "numeric", day: "numeric" };
      date = date.toLocaleDateString(undefined, options);
      return date;
    },
    historicCount(process) {
      return process.historic ? process.historic.length : 0;
    },
    historicLabel(process) {
      const historic = process.historic || [];
      if (!historic.length) return "Sin histórico de comparación";
      return historic.map((p) => p.nombre).join(" · ");
    },
    toggleMenu(id) {
      this.openMenuId = this.openMenuId === id ? null : id;
    },
    emitAction(event, process) {
      this.openMenuId = null;
      this.$emit(event, process);
    },
  },
};
</script>

<style lang="scss" scoped>
$brand: #510087;

.process-cards-mobile {
  padding: 0.5rem 0.25rem 1.5rem;
}

.process-search {
  margin-bottom: 0.75rem;

  .icon.is-left .material-icons {
    font-size: 20px;
    color: #b5b5b5;
  }
}

.process-create {
  margin-bottom: 1rem;
}

.process-card {
  padding: 1rem;
  margin-bottom: 0.85rem;
  cursor: pointer;
  border-left: 3px solid $brand;
  transition: box-shadow 0.15s ease, transform 0.05s ease;

  &:active {
    transform: scale(0.995);
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.process-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.process-card__title {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  color: #363636;
  line-height: 1.3;

  strong {
    color: #363636;
    overflow-wrap: break-word;
  }
}

.process-card__menu {
  flex: 0 0 auto;

  .dropdown-item {
    display: flex;
    align-items: center;
    gap: 8px;

    .material-icons {
      font-size: 18px;
    }
  }
}

.process-card__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
  margin-top: 0.6rem;
  color: #7a7a7a;
  font-size: 0.85rem;
}

.process-card__meta-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;

  .material-icons {
    font-size: 16px;
  }
}

.process-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 0.85rem;
}

.process-card__footer-group {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.process-card__toggle {
  gap: 4px;

  .material-icons {
    font-size: 20px;
  }

  &.is-grey {
    background-color: #f0f0f0;
    color: #7a7a7a;
  }
}

.process-empty {
  margin-top: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/climan/components/ProcessCardsMobile.vue